/* ═══════════════════════════════════════════════════════════════
   KALKI Fashion — Shopify Theme JS
   ════════════════════════════════════════════════════════════════ */

'use strict';

// ═══════════════════════ CART ═══════════════════════════════════

async function fetchCart() {
  const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
  return res.json();
}

async function renderCart() {
  const cart = await fetchCart();
  const countEls = [document.getElementById('cart-count'), document.getElementById('header-cart-count'), document.getElementById('desktop-cart-count')];
  const total = cart.item_count;

  countEls.forEach(el => {
    if (!el) return;
    el.textContent = total;
    if (el.id === 'header-cart-count' || el.id === 'desktop-cart-count') {
      el.classList.toggle('hidden', total === 0);
      el.classList.toggle('flex', total > 0);
    }
  });

  const itemsEl = document.getElementById('cart-items');
  const emptyEl = document.getElementById('cart-empty');
  const footerEl = document.getElementById('cart-footer');
  const subtotalEl = document.getElementById('cart-subtotal');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    if (emptyEl) emptyEl.style.display = 'block';
    if (footerEl) footerEl.classList.add('hidden');
    itemsEl.innerHTML = '';
    if (emptyEl) itemsEl.appendChild(emptyEl);
    return;
  }

  if (emptyEl) emptyEl.style.display = 'none';
  if (footerEl) footerEl.classList.remove('hidden');

  const subtotalPaise = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  let html = '';
  cart.items.forEach(item => {
    html += `
      <div class="flex gap-3 py-3 border-b border-gray-100" data-line-key="${item.key}">
        <a href="${item.url}" class="flex-shrink-0">
          <img src="${item.image}" alt="${item.title}" class="w-20 h-24 object-cover object-top bg-gray-50">
        </a>
        <div class="flex-1 min-w-0">
          <a href="${item.url}" class="text-xs font-medium line-clamp-2 hover:underline">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="text-xs text-gray-500 mt-0.5">${item.variant_title}</p>` : ''}
          ${renderLineItemProperties(item.properties)}
          <p class="text-xs text-gray-500 mt-0.5">${formatMoney(item.final_price)}</p>
          <div class="flex items-center gap-2 mt-2">
            <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})" class="w-6 h-6 border border-gray-300 flex items-center justify-center text-sm hover:border-black transition-colors">−</button>
            <span class="text-sm w-4 text-center">${item.quantity}</span>
            <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})" class="w-6 h-6 border border-gray-300 flex items-center justify-center text-sm hover:border-black transition-colors">+</button>
          </div>
          <button onclick="updateCartItem('${item.key}', 0)" class="text-[11px] text-gray-400 underline underline-offset-1 mt-1 hover:text-black transition-colors">Remove</button>
        </div>
      </div>`;
  });

  itemsEl.innerHTML = renderCartNudge(cart) + html;
  if (emptyEl && !itemsEl.contains(emptyEl)) itemsEl.appendChild(emptyEl);
  if (emptyEl) emptyEl.style.display = 'none';

  renderCartSavings(cart);
  renderCheckoutAmount(cart);
  renderCartCrossSell(cart, itemsEl);
}

// ── Multi-buy nudge: "Add 1 more → 10% off" (text comes from data-* on #cart-drawer) ──
function renderCartNudge(cart) {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return '';
  const qty = cart.items.reduce((n, i) => n + i.quantity, 0);
  const t1 = drawer.dataset.nudge1 || '';
  const t2 = drawer.dataset.nudge2 || '';
  const t3 = drawer.dataset.nudge3 || '';
  let text = '', pct = 0;
  if (qty === 1 && t1) { text = t1; pct = 33; }
  else if (qty === 2 && t2) { text = t2; pct = 66; }
  else if (qty >= 3 && t3) { text = t3; pct = 100; }
  if (!text) return '';
  return `
    <div class="kk-cart-nudge">
      <p>${escapeHtml(text)}</p>
      <div class="kk-cart-nudge-bar"><span style="width:${pct}%"></span></div>
    </div>`;
}

// ── "You saved ₹X" from automatic discounts + compare-at prices ──
function renderCartSavings(cart) {
  const el = document.getElementById('cart-savings');
  if (!el) return;
  let saved = cart.total_discount || 0;
  cart.items.forEach(i => {
    const cmp = parseInt(i.compare_at_price || 0, 10);
    if (cmp > i.final_price) saved += (cmp - i.final_price) * i.quantity;
  });
  if (saved > 0) { el.textContent = 'You saved ' + formatMoney(saved); el.hidden = false; }
  else el.hidden = true;
}

// ── Put the subtotal on the checkout button's sub-line ──
function renderCheckoutAmount(cart) {
  const sub = document.querySelector('#cart-footer .gokwik-checkout .btn-text span:last-child, #cart-footer #checkout-btn [data-amount]');
  if (sub) sub.textContent = formatMoney(cart.total_price);
}

// ── "Pairs well with": 3 recommendations for the first item, one-tap add ──
async function renderCartCrossSell(cart, itemsEl) {
  const first = cart.items[0];
  if (!first) return;
  const inCart = new Set(cart.items.map(i => i.product_id));
  try {
    const res = await fetch('/recommendations/products.json?product_id=' + first.product_id + '&limit=6&intent=related');
    if (!res.ok) return;
    const data = await res.json();
    const recs = (data.products || []).filter(p => !inCart.has(p.id) && p.available).slice(0, 3);
    if (!recs.length) return;
    const wrap = document.createElement('div');
    wrap.className = 'kk-cart-xsell';
    wrap.innerHTML = '<p class="kk-cart-xsell-title">Pairs well with</p>' + recs.map(p => {
      const img = (p.featured_image || (p.images && p.images[0]) || '');
      const v = p.variants && p.variants[0];
      const single = p.variants && p.variants.length === 1 && v && v.available;
      const price = formatMoney(p.price);
      const cta = single
        ? `<button type="button" class="kk-xsell-add" data-variant="${v.id}">ADD</button>`
        : `<a href="${p.url}" class="kk-xsell-add">VIEW</a>`;
      return `
        <div class="kk-xsell-item">
          <a href="${p.url}"><img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy"></a>
          <div class="kk-xsell-info">
            <a href="${p.url}" class="kk-xsell-name">${escapeHtml(p.title)}</a>
            <span class="kk-xsell-price">${price}</span>
          </div>
          ${cta}
        </div>`;
    }).join('');
    itemsEl.appendChild(wrap);
    wrap.querySelectorAll('.kk-xsell-add[data-variant]').forEach(btn => {
      btn.addEventListener('click', async () => {
        btn.textContent = '…'; btn.disabled = true;
        await addToCart(btn.dataset.variant, 1, false);
      });
    });
  } catch (e) { /* recommendations are optional */ }
}

async function updateCartItem(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  renderCart();
}

function formatMoney(cents) {
  const amount = (cents / 100).toFixed(0);
  return '₹' + parseInt(amount).toLocaleString('en-IN');
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Render customer-facing line-item properties (e.g. Blouse Stitching
// Option / Blouse Design) under a cart item. Underscore-prefixed and
// empty properties are hidden.
function renderLineItemProperties(properties) {
  if (!properties) return '';
  const rows = Object.keys(properties)
    .filter(function (k) { return k.charAt(0) !== '_' && properties[k] !== '' && properties[k] != null; })
    .map(function (k) {
      return `<span class="block"><strong>${escapeHtml(k)}:</strong> ${escapeHtml(properties[k])}</span>`;
    });
  return rows.length ? `<div class="bc-cart-props">${rows.join('')}</div>` : '';
}

function openCart() {
  document.getElementById('cart-drawer').style.transform = 'translateX(0)';
  const overlay = document.getElementById('cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'all';
  document.body.style.overflow = 'hidden';
  renderCart();
}

function closeCart() {
  document.getElementById('cart-drawer').style.transform = 'translateX(100%)';
  const overlay = document.getElementById('cart-overlay');
  overlay.style.opacity = '0';
  overlay.style.pointerEvents = 'none';
  document.body.style.overflow = '';
}

async function addToCart(variantId, quantity, openDrawer, properties) {
  quantity = quantity || 1;
  try {
    const payload = { id: variantId, quantity };
    // Line-item properties (e.g. Blouse Stitching Option / Blouse Design).
    if (properties && Object.keys(properties).length) payload.properties = properties;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) {
      const err = await res.json();
      alert(err.description || 'Could not add to cart');
      return;
    }
    if (openDrawer !== false) openCart();
    else renderCart();
  } catch (e) {
    console.error('Add to cart error:', e);
  }
}

// Harvest line-item properties from enabled, non-empty `properties[...]`
// inputs inside a form. Needed because this theme submits the cart over
// AJAX (JSON), so native <input> submission does not apply. Inputs that
// are disabled or empty are skipped, so feature modules can opt a property
// out of submission simply by disabling its hidden input.
function collectLineItemProperties(form) {
  const properties = {};
  if (!form) return properties;
  form.querySelectorAll('[name^="properties["]').forEach(function (input) {
    if (input.disabled || input.value === '') return;
    const match = input.name.match(/^properties\[(.+)\]$/);
    if (match) properties[match[1]] = input.value;
  });
  return properties;
}

// ═══════════════════════ MOBILE DRAWER ════════════════════════

function openMobileDrawer() {
  document.getElementById('mobile-drawer').style.transform = 'translateX(0)';
  const overlay = document.getElementById('mobile-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'all';
  document.body.style.overflow = 'hidden';
}

function closeMobileDrawer() {
  document.getElementById('mobile-drawer').style.transform = 'translateX(-100%)';
  const overlay = document.getElementById('mobile-overlay');
  overlay.style.opacity = '0';
  overlay.style.pointerEvents = 'none';
  document.body.style.overflow = '';
}

// ═══════════════════════ MOBILE SEARCH ════════════════════════

let searchOpen = false;
function toggleMobileSearch() {
  const el = document.getElementById('mobile-search');
  if (!el) return;
  searchOpen = !searchOpen;
  if (searchOpen) {
    el.style.height = el.scrollHeight + 'px';
    el.style.opacity = '1';
    setTimeout(() => { const inp = el.querySelector('input'); if (inp) inp.focus(); }, 200);
  } else {
    el.style.height = '0';
    el.style.opacity = '0';
  }
}

// ═══════════════════════ MEGA MENU ════════════════════════════

const MEGA_MENUS = {
  'saree': {
    items: [
      { label: 'See All Sarees', href: '/collections/sarees', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/lime-green-embellished-net-saree-sg395203-1.jpg' },
      { label: 'Ready To Ship', href: '/collections/new-arrivals', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/wine-kora-silk-saree-sg395201-1.jpg' },
      { label: 'Embroidered Sarees', href: '/collections/sarees', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/1-top-embroidered-saree-page-all-countries-10-06-26.jpg' },
      { label: 'Net Sarees', href: '/collections/sarees', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lime-green-embellished-net-saree-sg395203-1.jpg' },
      { label: 'Silk Sarees', href: '/collections/sarees', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/wine-kora-silk-saree-sg395201-1.jpg' },
    ]
  },
  'salwar-kameez': {
    items: [
      { label: 'See All Salwar Kameez', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embellished-art-silk-kurta-set-sg330117-1_6b3cf7d7-c6ef-41f4-8356-2c70694200a6.jpg' },
      { label: 'Anarkali Suits', href: '/collections/anarkali-suits', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/2-top-collection-anarkali-suits-all-countries-10-06-26.jpg' },
      { label: 'Straight Suits', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/purple-kurta-set-with-cut-dana-and-sequins-work-sg395207-1_ad4fc461-1381-4e40-ac9a-b38a1a1d2b58.jpg' },
      { label: 'Embroidered Suits', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
      { label: 'Palazzo Sets', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lavender-embroidered-crepe-cape-jacket-skirt-set-sg311131-1.jpg' },
    ]
  },
  'lehenga': {
    items: [
      { label: 'See All Lehenga', href: '/collections/lehengas', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/4-top-collection-lehenga-all-countries-10-06-26.jpg' },
      { label: 'Ready To Ship', href: '/collections/lehengas', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/green-embellished-organza-crop-top-skirt-set-sg395205-1.jpg' },
      { label: 'Embroidered Lehenga', href: '/collections/lehengas', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-raw-silk-kurta-jacket-set-sg329325-1_f86e8a12-482a-4f09-8c08-b1cab8c9e941.jpg' },
      { label: 'Traditional Lehenga', href: '/collections/lehengas', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lavender-embroidered-crepe-cape-jacket-skirt-set-sg311131-1.jpg' },
      { label: 'Printed Lehenga', href: '/collections/lehengas', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
    ]
  },
  'indo-western': {
    items: [
      { label: 'See All Indo Western', href: '/collections/indo-western', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/4-curated-collections-indo-western-all-countries-400x533-10-06-26.jpg' },
      { label: 'Cape Styles', href: '/collections/cape-styles', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/2-curated-collections-cape-style-all-countries-400x533-10-06-26.jpg' },
      { label: 'Crop Top & Skirt', href: '/collections/blouses', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/3-top-collection-crop-top-styles-all-countries-10-06-26.jpg' },
      { label: 'Jacket Sets', href: '/collections/men', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-raw-silk-kurta-jacket-set-sg329325-1_f86e8a12-482a-4f09-8c08-b1cab8c9e941.jpg' },
      { label: 'Printed Styles', href: '/collections/printed-collection', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/3-curated-collections-printed-collection-all-countries-400x533-10-06-26.jpg' },
    ]
  },
  'men': {
    items: [
      { label: 'See All Men', href: '/collections/men', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embroidered-silk-kurta-set-sg369737-1_39ba8861-36f4-4c3b-b446-0c2560aa750b.jpg' },
      { label: 'Kurta Sets', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/wine-silk-kurta-set-for-men-with-mirror-work-sg361739-1_d414394c-0f88-4efd-aa2a-5126a84e82e1.jpg' },
      { label: 'Kurta Jacket Sets', href: '/collections/anarkali-suits', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/5-top-collection-men_s-kurta-and-jacket-set-all-countries-10-06-26.jpg' },
      { label: 'Sherwanis', href: '/collections/men', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lilac-mens-jacquard-self-work-kurta-and-pant-set-sg321412-1.jpg' },
      { label: 'Indo Western', href: '/collections/men', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/beige-silk-jacquard-kurta-set-for-men-with-printed-stripes-sg321444-1.jpg' },
    ]
  },
  'jewellery': {
    items: [
      { label: 'See All Jewellery', href: '/collections/all', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embellished-art-silk-kurta-set-sg330117-1_6b3cf7d7-c6ef-41f4-8356-2c70694200a6.jpg' },
      { label: 'Necklaces', href: '/collections/all', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/purple-kurta-set-with-cut-dana-and-sequins-work-sg395207-1_ad4fc461-1381-4e40-ac9a-b38a1a1d2b58.jpg' },
      { label: 'Earrings', href: '/collections/all', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
      { label: 'Bangles', href: '/collections/all', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/green-embellished-organza-crop-top-skirt-set-sg395205-1.jpg' },
      { label: 'Maang Tikka', href: '/collections/all', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lavender-embroidered-crepe-cape-jacket-skirt-set-sg311131-1.jpg' },
    ]
  },
  'co-ords': {
    items: [
      { label: 'See All Co-Ords', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
      { label: 'Printed Co-Ords', href: '/collections/blouses', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/3-curated-collections-printed-collection-all-countries-400x533-10-06-26.jpg' },
      { label: 'Embroidered Co-Ords', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/purple-kurta-set-with-cut-dana-and-sequins-work-sg395207-1_ad4fc461-1381-4e40-ac9a-b38a1a1d2b58.jpg' },
      { label: 'Festive Co-Ords', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embellished-art-silk-kurta-set-sg330117-1_6b3cf7d7-c6ef-41f4-8356-2c70694200a6.jpg' },
      { label: 'Casual Co-Ords', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/green-embellished-organza-crop-top-skirt-set-sg395205-1.jpg' },
    ]
  },
  'blouse': {
    items: [
      { label: 'See All Blouses', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/powder_blue_pleated_blouse-sg230352_4_b5936122-6d1d-49e6-a3c6-e4a5a174959f.jpg' },
      { label: 'Embroidered Blouses', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/bottle-green-crop-top-in-velvet-with-double-straps-and-v-neckline-online-kalki-fashion-sg43179_3.jpg' },
      { label: 'Designer Blouses', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/mint-green-square-neck-blouse-with-back-dori-sg389642-1_a5d49aa6-1fca-48e3-8824-48b7a0daa478.jpg' },
      { label: 'Silk Blouses', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/emerald_green_sleeveless_blouse_in_raw_silk_with_strappy_back_hook_-sg147507_2.jpg' },
      { label: 'Crop Top Blouses', href: '/collections/blouses', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/black-sleeveless-blouse-in-raw-silk-with-sweetheart-neckline-sg147505-1.jpg' },
    ]
  },
  'bestsellers': {
    items: [
      { label: 'All Bestsellers', href: '/collections/trending-now', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/1-top-embroidered-saree-page-all-countries-10-06-26.jpg' },
      { label: 'Most Wishlisted', href: '/collections/most-wishlisted', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embroidered-silk-kurta-set-sg369737-1_39ba8861-36f4-4c3b-b446-0c2560aa750b.jpg' },
      { label: 'Trending Sarees', href: '/collections/sarees', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lime-green-embellished-net-saree-sg395203-1.jpg' },
      { label: 'Trending Lehengas', href: '/collections/lehengas', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/4-top-collection-lehenga-all-countries-10-06-26.jpg' },
      { label: 'Trending Kurtas', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
    ]
  },
  'new-arrivals': {
    items: [
      { label: 'See All New', href: '/collections/new-arrivals', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-silk-palazzo-set-with-zari-and-sequins-work-sg381449-1_135155c5-af80-4122-b35c-d6dcf9f96098.jpg' },
      { label: 'New Sarees', href: '/collections/sarees', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/lime-green-embellished-net-saree-sg395203-1.jpg' },
      { label: 'New Lehengas', href: '/collections/lehengas', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/4-top-collection-lehenga-all-countries-10-06-26.jpg' },
      { label: 'New Kurta Sets', href: '/collections/anarkali-suits', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/purple-kurta-set-with-cut-dana-and-sequins-work-sg395207-1_ad4fc461-1381-4e40-ac9a-b38a1a1d2b58.jpg' },
      { label: "New Men's Wear", href: '/collections/men', image: 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/pink-embroidered-silk-kurta-set-sg369737-1_39ba8861-36f4-4c3b-b446-0c2560aa750b.jpg' },
    ]
  },
  'wedding-collection': {
    items: [
      { label: 'Bridal Wear', href: '/collections/bridal', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/1-bridal-world-day-haldi-and-mehendi-edit-countries-10-06-26.jpg' },
      { label: 'Haldi & Mehendi', href: '/collections/bridal', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/1-bridal-world-day-haldi-and-mehendi-edit-countries-10-06-26.jpg' },
      { label: 'Cocktail & Sangeet', href: '/collections/bridal', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/3-bridal-world-day-cocktail-and-sangeet-edit-all-countries-10-06-26.jpg' },
      { label: 'Roka Ready Looks', href: '/collections/bridal', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/main-bridal-banner-guest-wedding-collection-11-06-26.jpg' },
      { label: 'Wedding Wow Fits', href: '/collections/bridal', image: 'https://ik.imagekit.io/4sjmoqtje/tr:w-220,c-at_max/cdn/shop/files/4-bridal-world-wedding-collection-all-countries-10-06-26.jpg' },
    ]
  },
};

// ═══════════════════════ SHOP BY (sort/filter mega menu) ═══════
const SHOP_BY = {
  'Fabric': [
    { label: 'Cotton', href: '/collections/cotton-sarees' },
    { label: 'Silk', href: '/collections/silk-sarees' },
    { label: 'Satin', href: '/collections/satin-sarees' },
    { label: 'Chiffon', href: '/collections/chiffon-sarees' },
    { label: 'Velvet', href: '/collections/velvet-sarees' },
    { label: 'Organza', href: '/collections/organza-sarees' },
    { label: 'Georgette', href: '/collections/georgette-sarees' },
  ],
  'Occasion': [
    { label: 'Office Wear', href: '/collections/office-wear-sarees' },
    { label: 'Party Wear', href: '/collections/party-wear-sarees' },
    { label: 'Elegant Evening Sarees', href: '/collections/elegant-evening-sarees' },
    { label: 'Festive Sarees', href: '/collections/festive-sarees' },
    { label: 'Cocktail Sarees', href: '/collections/cocktail-sarees' },
    { label: 'Everyday Sarees', href: '/collections/everyday-sarees' },
  ],
  'Collection': [
    { label: 'Ready To Drape', href: '/collections/ready-to-drape' },
    { label: 'Glam Gharana', href: '/collections/glam-gharana' },
    { label: 'The Kanak Edit', href: '/collections/the-kanak-edit' },
    { label: 'Chitra Virasat', href: '/collections/chitra-virasat' },
    { label: 'Twirl in Prints', href: '/collections/twirl-in-prints' },
    { label: 'Pure Comfort Edits', href: '/collections/pure-comfort-edits' },
    { label: 'Spark & Silk Party Edits', href: '/collections/spark-silk-party-edits' },
    { label: 'Artistry in Prints', href: '/collections/artistry-in-prints' },
    { label: 'The Corporate Collection', href: '/collections/the-corporate-collection' },
  ],
  'Price': [
    { label: 'Under ₹1,599', href: '/collections/sarees-under-1599' },
    { label: 'Under ₹1,999', href: '/collections/sarees-under-1999' },
    { label: 'Under ₹2,499', href: '/collections/sarees-under-2499' },
    { label: 'Premium Collection', href: '/collections/premium-collection' },
  ],
};

function buildShopByMenu() {
  const cols = Object.keys(SHOP_BY).map(cat => {
    const links = SHOP_BY[cat].map(item =>
      `<a href="${item.href}" class="mega-menu__link">${item.label}</a>`
    ).join('');
    return `<div class="mega-menu__col"><p class="mega-menu__title">${cat}</p>${links}</div>`;
  }).join('');

  // Optional featured promo card (fills the right side); configured on #sub-nav
  let feature = '';
  const sn = document.getElementById('sub-nav');
  if (sn && sn.dataset.featImage) {
    const url = sn.dataset.featUrl || '/collections';
    const heading = sn.dataset.featHeading || '';
    const cta = sn.dataset.featCta || 'Explore';
    feature =
      '<div class="mega-menu__feature"><a href="' + url + '">' +
        '<img class="mega-menu__feature-img" src="' + sn.dataset.featImage + '" alt="' + heading + '" loading="lazy">' +
        (heading ? '<p class="mega-menu__feature-heading">' + heading + '</p>' : '') +
        '<span class="mega-menu__feature-cta">' + cta + ' &rarr;</span>' +
      '</a></div>';
  }
  return '<div class="mega-menu__inner">' + cols + feature + '</div>';
}

function buildMegaMenu(slug) {
  if (slug === 'shop-by') return buildShopByMenu();
  const data = MEGA_MENUS[slug];
  if (!data) return '';
  const leftLinks = ['STYLE', 'OCCASION', 'SHOPPER', 'COLLECTIONS', 'QUICK LINK', 'COLOR'];
  const leftHtml = leftLinks.map(l => `
    <button class="block text-xs font-bold tracking-widest text-gray-800 uppercase py-2.5 hover:text-black transition-colors border-b border-gray-100 w-full text-left">${l}</button>
  `).join('');
  const rightHtml = data.items.map(item => `
    <a href="${item.href}" class="group flex flex-col">
      <div class="overflow-hidden bg-gray-50 aspect-3-4">
        <img src="${item.image}" alt="${item.label}" class="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" loading="lazy">
      </div>
      <p class="text-[11px] text-center text-gray-700 mt-2 font-medium leading-snug group-hover:text-black transition-colors">${item.label}</p>
    </a>
  `).join('');
  return `
    <div class="w-56 flex-shrink-0 bg-[#faf6f2] border-r border-gray-100 py-6 px-5">
      <p class="text-[9px] font-bold tracking-[0.2em] uppercase text-gray-400 mb-4">Filter By</p>
      ${leftHtml}
    </div>
    <div class="flex-1 p-6">
      <div class="grid grid-cols-5 gap-4">${rightHtml}</div>
    </div>
  `;
}

function initMegaMenu() {
  const subNav = document.getElementById('sub-nav');
  if (!subNav) return;

  let megaEl = document.getElementById('mega-menu-panel');
  if (!megaEl) {
    megaEl = document.createElement('div');
    megaEl.id = 'mega-menu-panel';
    megaEl.className = 'mega-menu';
    subNav.appendChild(megaEl);
  }

  const triggers = subNav.querySelectorAll('[data-mega]');
  let activeSlug = null;
  let leaveTimer = null;

  function setExpanded(state) {
    triggers.forEach(t => t.setAttribute('aria-expanded', state ? 'true' : 'false'));
  }

  function showMenu(slug) {
    if (leaveTimer) clearTimeout(leaveTimer);
    if (!slug || (!MEGA_MENUS[slug] && slug !== 'shop-by')) { hideMenu(true); return; }
    if (slug !== activeSlug) {
      activeSlug = slug;
      megaEl.innerHTML = buildMegaMenu(slug);
    }
    megaEl.classList.add('active');
    setExpanded(true);
  }

  function hideMenu(immediate) {
    if (leaveTimer) clearTimeout(leaveTimer);
    const close = () => { megaEl.classList.remove('active'); activeSlug = null; setExpanded(false); };
    if (immediate) close();
    else leaveTimer = setTimeout(close, 120);
  }

  function keepMenu() { if (leaveTimer) clearTimeout(leaveTimer); }

  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => showMenu(trigger.dataset.mega));
    trigger.addEventListener('focus', () => showMenu(trigger.dataset.mega));
  });

  subNav.addEventListener('mouseleave', () => hideMenu());
  megaEl.addEventListener('mouseenter', keepMenu);
  megaEl.addEventListener('mouseleave', () => hideMenu());
  // Escape closes; moving focus outside the nav/panel closes
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideMenu(true); });
  document.addEventListener('focusin', (e) => {
    if (!megaEl.classList.contains('active')) return;
    if (subNav.contains(e.target) || megaEl.contains(e.target)) return;
    hideMenu(true);
  });
}

// ═══════════════════════ HERO SLIDER ════════════════════════

// Mobile drawer "Shop By" — nested accordion built from the SHOP_BY data.
function initMobileShopBy() {
  const container = document.getElementById('mobile-shopby');
  if (!container || typeof SHOP_BY === 'undefined') return;

  const chevRight = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';
  const chevDown  = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';

  const cats = Object.keys(SHOP_BY).map(cat => {
    const links = SHOP_BY[cat].map(item =>
      `<a href="${item.href}" class="block py-2.5 pl-5 pr-3 text-[13px] text-gray-600 hover:text-black border-b border-gray-50">${item.label}</a>`
    ).join('');
    return `<div class="mob-sb-cat">
      <button type="button" class="mob-sb-cat-toggle w-full flex items-stretch justify-between border-b border-gray-100 text-gray-800">
        <span class="text-sm py-2.5 pl-3">${cat}</span>
        <span class="mob-sb-cat-chev flex items-center justify-center w-11 border-l border-gray-100 text-gray-500">${chevRight}</span>
      </button>
      <div class="mob-sb-cat-panel bg-[#FFFAF3]" hidden>${links}</div>
    </div>`;
  }).join('');

  container.innerHTML =
    `<button type="button" class="mob-sb-toggle w-full flex items-stretch justify-between border-b border-gray-50 text-gray-700">
       <span class="text-sm py-2.5">Shop By</span>
       <span class="mob-sb-chev flex items-center justify-center w-11 text-gray-500">${chevDown}</span>
     </button>
     <div class="mob-sb-panel" hidden>${cats}</div>`;

  const toggle = container.querySelector('.mob-sb-toggle');
  const panel  = container.querySelector('.mob-sb-panel');
  const chevCell = toggle.querySelector('.mob-sb-chev');
  const chevSvg = chevCell.querySelector('svg');
  toggle.addEventListener('click', () => {
    const willOpen = panel.hidden;
    panel.hidden = !willOpen;
    chevSvg.style.transform = willOpen ? 'rotate(180deg)' : '';
    chevCell.classList.toggle('mob-sb-chev-active', willOpen);
    toggle.classList.toggle('bg-gray-50', willOpen);
  });

  container.querySelectorAll('.mob-sb-cat-toggle').forEach(btn => {
    const p = btn.nextElementSibling;
    const svg = btn.querySelector('.mob-sb-cat-chev svg');
    btn.addEventListener('click', () => {
      const willOpen = p.hidden;
      container.querySelectorAll('.mob-sb-cat-panel').forEach(o => { if (o !== p) o.hidden = true; });
      container.querySelectorAll('.mob-sb-cat-chev svg').forEach(o => { if (o !== svg) o.style.transform = ''; });
      p.hidden = !willOpen;
      svg.style.transform = willOpen ? 'rotate(90deg)' : '';
    });
  });
}

function initHeroSlider() {
  const container = document.getElementById('hero-slider');
  if (!container) return;

  const track = container.querySelector('.hero-track');
  const slides = Array.from(container.querySelectorAll('.hero-slide'));
  const dots = container.querySelectorAll('.hero-dot');
  const n = slides.length;
  if (!track || n === 0) return;

  const autoplay = container.dataset.autoplay !== 'false';
  const interval = (parseInt(container.dataset.interval, 10) || 5) * 1000;

  if (n === 1) return; // nothing to slide

  // Clone first + last slides so the carousel pans smoothly and loops
  // seamlessly in both directions (no reverse jump on wrap-around).
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[n - 1].cloneNode(true);
  firstClone.classList.add('is-clone');
  lastClone.classList.add('is-clone');
  firstClone.removeAttribute('id');
  lastClone.removeAttribute('id');
  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);
  // track order: [lastClone, s0, s1, ... s(n-1), firstClone]

  let index = 1;        // start on the first real slide
  let timer = null;
  let animating = false;

  function place(animate) {
    if (animate) {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
    } else {
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      void track.offsetWidth;        // flush so the jump is instant
      track.style.transition = '';   // restore the CSS transition
    }
  }
  function updateDots() {
    const real = (index - 1 + n) % n;
    dots.forEach((d, i) => d.classList.toggle('active', i === real));
  }
  place(false);
  updateDots();

  function go(dir) {
    if (animating) return;
    animating = true;
    index += dir;
    place(true);
    updateDots();
  }
  function goTo(real) {
    if (animating || real === (index - 1 + n) % n) return;
    animating = true;
    index = real + 1;
    place(true);
    updateDots();
  }

  track.addEventListener('transitionend', function (e) {
    if (e.target !== track || e.propertyName !== 'transform') return;
    animating = false;
    if (index === n + 1) { index = 1; place(false); }       // past last → real first
    else if (index === 0) { index = n; place(false); }      // before first → real last
  });

  function start() { stop(); if (autoplay) timer = setInterval(() => go(1), interval); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  const prevBtn = container.querySelector('.hero-prev');
  const nextBtn = container.querySelector('.hero-next');
  if (prevBtn) prevBtn.addEventListener('click', () => { stop(); go(-1); start(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { stop(); go(1); start(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { stop(); goTo(i); start(); }));

  container.addEventListener('mouseenter', stop);
  container.addEventListener('mouseleave', start);

  start();
}

// ═══════════════════════ CUSTOMER STORIES CAROUSEL ════════════

function initCustomerStories() {
  const section = document.getElementById('customer-stories');
  if (!section) return;

  const track = section.querySelector('.stories-track');
  const cards = section.querySelectorAll('.story-card');
  const prevBtn = section.querySelector('.stories-prev');
  const nextBtn = section.querySelector('.stories-next');
  const dotsEl = section.querySelector('.stories-dots');
  if (!track || cards.length === 0) return;

  let perPage = getPerPage();
  let current = 0;
  const total = cards.length;

  function getPerPage() {
    if (window.innerWidth < 640) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  }

  function setWidths() {
    perPage = getPerPage();
    const cardWidth = 100 / perPage;
    cards.forEach(card => {
      card.style.width = cardWidth + '%';
    });
    current = Math.min(current, total - perPage);
    render();
    buildDots();
  }

  function buildDots() {
    if (!dotsEl) return;
    const count = total - perPage + 1;
    dotsEl.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      dot.className = 'w-2 h-2 rounded-full transition-all ' + (i === current ? 'bg-black w-5' : 'bg-gray-300');
      dot.addEventListener('click', () => { current = i; render(); updateDots(); });
      dotsEl.appendChild(dot);
    }
  }

  function updateDots() {
    if (!dotsEl) return;
    const dots = dotsEl.querySelectorAll('button');
    dots.forEach((dot, i) => {
      dot.className = 'w-2 h-2 rounded-full transition-all ' + (i === current ? 'bg-black' : 'bg-gray-300');
      dot.style.width = i === current ? '20px' : '8px';
    });
  }

  function render() {
    track.style.transform = `translateX(-${current * (100 / perPage)}%)`;
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current >= total - perPage;
    updateDots();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { if (current > 0) { current--; render(); } });
  if (nextBtn) nextBtn.addEventListener('click', () => { if (current < total - perPage) { current++; render(); } });

  setWidths();
  window.addEventListener('resize', setWidths);
}

// ═══════════════════════ PRODUCT PAGE ════════════════════════

function initProductPage() {
  // ── Image gallery carousel (native horizontal swipe + scroll-snap) ──
  const gallery = document.getElementById('product-gallery');
  const slides = gallery ? Array.from(gallery.querySelectorAll('.product-slide')) : [];
  const thumbs = Array.from(document.querySelectorAll('.product-thumb'));
  const dotsWrap = document.getElementById('gallery-dots');

  const visibleSlides = () => slides.filter(s => s.style.display !== 'none');
  function scrollToSlide(slide, smooth) {
    if (!slide || !gallery) return;
    gallery.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  }
  function currentSlideIndex() {
    const vis = visibleSlides();
    if (!gallery || !vis.length) return 0;
    const center = gallery.scrollLeft + gallery.clientWidth / 2;
    let best = 0, bestD = Infinity;
    vis.forEach((s, i) => {
      const c = s.offsetLeft + s.clientWidth / 2;
      const d = Math.abs(c - center);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }
  function syncGalleryActive() {
    const vis = visibleSlides();
    const ci = currentSlideIndex();
    const key = vis[ci] && vis[ci].dataset.full ? vis[ci].dataset.full.split('?')[0] : '';
    thumbs.forEach(t => t.classList.toggle('active', (t.dataset.full || '').split('?')[0] === key));
    if (dotsWrap) dotsWrap.querySelectorAll('.gallery-dot').forEach((d, i) => d.classList.toggle('active', i === ci));
  }
  function buildDots() {
    if (!dotsWrap) return;
    const n = visibleSlides().length;
    dotsWrap.innerHTML = Array.from({ length: n }, (_, i) => '<span class="gallery-dot" data-i="' + i + '"></span>').join('');
    syncGalleryActive();
  }
  if (gallery) {
    let st;
    gallery.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(syncGalleryActive, 50); }, { passive: true });
    if (dotsWrap) dotsWrap.addEventListener('click', e => {
      const d = e.target.closest('.gallery-dot'); if (!d) return;
      scrollToSlide(visibleSlides()[+d.dataset.i], true);
    });
    buildDots();
  }
  // Desktop thumbnails scroll the carousel to the matching slide.
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const key = (thumb.dataset.full || '').split('?')[0];
      const slide = slides.find(s => (s.dataset.full || '').split('?')[0] === key);
      if (slide) scrollToSlide(slide, true);
    });
  });

  // Size selection
  const sizeBtns = document.querySelectorAll('.size-btn');
  const sizeInput = document.getElementById('selected-variant-id');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('out-of-stock')) return;
      sizeBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      if (sizeInput) sizeInput.value = btn.dataset.variantId;
    });
  });

  // Colour selection — filters the gallery to the colour's images; previews sold-out colours too
  const colorBtns = document.querySelectorAll('.color-swatch');
  const atcButton = document.getElementById('add-to-cart-btn');

  function showColorGroup(variantId) {
    thumbs.forEach(t => {
      const grp = t.dataset.variantGroup;
      t.style.display = (!grp || grp === String(variantId)) ? '' : 'none';
      t.classList.remove('active');
    });
    slides.forEach(s => {
      const grp = s.dataset.variantGroup;
      s.style.display = (!grp || grp === String(variantId)) ? '' : 'none';
    });
    buildDots();
    const first = visibleSlides()[0];
    if (first) scrollToSlide(first, false);
    syncGalleryActive();
  }

  colorBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      colorBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      if (sizeInput) sizeInput.value = btn.dataset.variantId;

      showColorGroup(btn.dataset.variantId);

      const nameEl = document.getElementById('selected-color-name');
      if (nameEl && btn.dataset.variantName) nameEl.textContent = btn.dataset.variantName;

      const priceEl = document.getElementById('js-price-current');
      if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;
      // Keep compare-at, % off and the sticky bar in sync with the chosen colour
      const cmpEl = document.getElementById('js-price-compare');
      const pctEl = document.getElementById('js-price-pct');
      const cmpPaise = parseInt(btn.dataset.variantCompare || '0', 10);
      const pricePaise = parseInt(btn.dataset.variantPricePaise || '0', 10);
      if (cmpEl && pctEl) {
        if (cmpPaise > pricePaise && pricePaise > 0) {
          cmpEl.textContent = formatMoney(cmpPaise);
          pctEl.textContent = '(' + Math.floor((cmpPaise - pricePaise) * 100 / cmpPaise) + '% OFF)';
          cmpEl.hidden = false; pctEl.hidden = false;
        } else {
          cmpEl.hidden = true; pctEl.hidden = true;
        }
      }
      const stickyPrice = document.getElementById('kk-sticky-price');
      if (stickyPrice && btn.dataset.variantPrice) {
        stickyPrice.innerHTML = btn.dataset.variantPrice + (cmpPaise > pricePaise && pricePaise > 0 ? ' <s>' + formatMoney(cmpPaise) + '</s>' : '');
      }

      // Reflect this colour's availability on the Add to Bag button
      if (atcButton) {
        const available = btn.dataset.variantAvailable === 'true';
        atcButton.disabled = !available;
        atcButton.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
        atcButton.style.opacity = available ? '' : '0.5';
        atcButton.style.cursor = available ? '' : 'not-allowed';
      }
    });
  });

  // On load, if this product has colours, show only the current colour's images.
  if (colorBtns.length) {
    const selected = document.querySelector('.color-swatch.selected') || colorBtns[0];
    if (selected) showColorGroup(selected.dataset.variantId);
  }

  // ── Fullscreen lightbox (tap a slide to view large; navigate + zoom) ──
  if (gallery && slides.length) {
    const lb = document.createElement('div');
    lb.className = 'kk-lightbox';
    lb.innerHTML =
      '<button class="kk-lb-close" aria-label="Close">&times;</button>' +
      '<button class="kk-lb-nav kk-lb-prev" aria-label="Previous image">&#8249;</button>' +
      '<div class="kk-lb-stage"><img class="kk-lb-img" alt=""></div>' +
      '<button class="kk-lb-nav kk-lb-next" aria-label="Next image">&#8250;</button>' +
      '<div class="kk-lb-counter"></div>';
    document.body.appendChild(lb);

    const lbImg = lb.querySelector('.kk-lb-img');
    const lbCounter = lb.querySelector('.kk-lb-counter');
    const prevBtn = lb.querySelector('.kk-lb-prev');
    const nextBtn = lb.querySelector('.kk-lb-next');
    let lgallery = [];
    let idx = 0;

    function render() {
      lbImg.classList.remove('zoomed');
      lbImg.style.transformOrigin = 'center center';
      lbImg.src = lgallery[idx] || '';
      lbCounter.textContent = lgallery.length > 1 ? (idx + 1) + ' / ' + lgallery.length : '';
      const multi = lgallery.length > 1 ? '' : 'none';
      prevBtn.style.display = multi; nextBtn.style.display = multi;
    }
    function openLb(src) {
      lgallery = visibleSlides().map(s => s.dataset.full).filter(Boolean);
      const i = lgallery.findIndex(s => s.split('?')[0] === (src || '').split('?')[0]);
      idx = i < 0 ? 0 : i;
      render();
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; }
    function go(d) { if (lgallery.length) { idx = (idx + d + lgallery.length) % lgallery.length; render(); } }

    // Tap a slide opens the lightbox (a horizontal swipe scrolls and does not fire click).
    slides.forEach(s => {
      s.style.cursor = 'zoom-in';
      s.addEventListener('click', () => openLb(s.dataset.full));
    });
    lb.querySelector('.kk-lb-close').addEventListener('click', closeLb);
    prevBtn.addEventListener('click', e => { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', e => { e.stopPropagation(); go(1); });
    lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('kk-lb-stage')) closeLb(); });
    lbImg.addEventListener('click', e => { e.stopPropagation(); lbImg.classList.toggle('zoomed'); });
    lbImg.addEventListener('mousemove', e => {
      if (!lbImg.classList.contains('zoomed')) return;
      const r = lbImg.getBoundingClientRect();
      lbImg.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
    });
    document.addEventListener('keydown', e => {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
  }

  // Add to cart
  const atcForm = document.getElementById('add-to-cart-form');
  const atcBtn = document.getElementById('add-to-cart-btn');
  if (atcForm && atcBtn) {
    atcForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const variantId = sizeInput ? sizeInput.value : null;
      if (!variantId) {
        atcBtn.classList.add('shake');
        setTimeout(() => atcBtn.classList.remove('shake'), 500);
        const hint = document.getElementById('size-error');
        if (hint) { hint.classList.remove('hidden'); setTimeout(() => hint.classList.add('hidden'), 3000); }
        return;
      }
      // Let feature modules (e.g. blouse customizer) veto the submit.
      const proceed = atcForm.dispatchEvent(new CustomEvent('atc:validate', { cancelable: true }));
      if (!proceed) return;
      // Gather any line-item properties present in the form.
      const properties = collectLineItemProperties(atcForm);
      atcBtn.textContent = 'ADDING...';
      atcBtn.disabled = true;
      await addToCart(variantId, 1, true, properties);
      atcBtn.textContent = 'ADD TO BAG';
      atcBtn.disabled = false;
    });
  }

  // Accordion
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      const chevron = trigger.querySelector('.accordion-chevron');
      const isOpen = body.classList.contains('open');
      // close all
      document.querySelectorAll('.accordion-body').forEach(b => {
        b.classList.remove('open');
        b.style.height = '0';
      });
      document.querySelectorAll('.accordion-chevron').forEach(c => c.classList.remove('open'));
      if (!isOpen && body) {
        body.classList.add('open');
        body.style.height = body.scrollHeight + 'px';
        if (chevron) chevron.classList.add('open');
      }
    });
  });
}

// ═══════════════════════ ANNOUNCEMENT SCROLL ════════════════════

function initAnnouncement() {
  const marquee = document.querySelector('.announce-track');
  if (marquee) {
    marquee.innerHTML += marquee.innerHTML;
  }
}

// ═══════════════════════ WISHLIST (localStorage) ═══════════════
const WISHLIST_KEY = 'kalki_wishlist';

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
}
function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  updateWishlistUI();
}
function toggleWishlist(item) {
  const items = getWishlist();
  const idx = items.findIndex(i => i.handle === item.handle);
  if (idx >= 0) items.splice(idx, 1); else items.push(item);
  saveWishlist(items);
}
function updateWishlistUI() {
  const items = getWishlist();
  const handles = items.map(i => i.handle);
  document.querySelectorAll('[data-wishlist-count]').forEach(el => {
    el.textContent = items.length;
    el.classList.toggle('hidden', items.length === 0);
    el.classList.toggle('flex', items.length > 0);
  });
  document.querySelectorAll('[data-wishlist]').forEach(btn => {
    const active = handles.indexOf(btn.getAttribute('data-wishlist-handle')) >= 0;
    const svg = btn.querySelector('svg');
    if (svg) { svg.style.fill = active ? '#5B061F' : 'none'; svg.style.stroke = active ? '#5B061F' : 'currentColor'; }
    const label = btn.querySelector('[data-wishlist-label]');
    if (label) label.textContent = active ? 'WISHLISTED' : 'WISHLIST';
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  renderWishlistPage();
}
function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  if (!grid) return;
  const empty = document.getElementById('wishlist-empty');
  const items = getWishlist();
  if (!items.length) {
    grid.innerHTML = '';
    if (empty) empty.style.display = 'block';
    return;
  }
  if (empty) empty.style.display = 'none';
  grid.innerHTML = items.map(item => `
    <div class="group relative">
      <a href="${item.url}" class="block overflow-hidden bg-gray-50 aspect-3-4">
        <img src="${item.image}" alt="${escapeHtml(item.title)}" class="w-full h-full object-cover object-top product-image" loading="lazy">
      </a>
      <button type="button" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Remove from wishlist"
        class="absolute top-2 right-2 w-8 h-8 bg-white/90 hover:bg-white flex items-center justify-center shadow-sm">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#5B061F" stroke="#5B061F" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
      </button>
      <div class="mt-2.5">
        <a href="${item.url}"><h3 class="text-xs text-gray-800 leading-snug hover:text-black mb-1.5 line-clamp-2">${escapeHtml(item.title)}</h3></a>
        <p class="text-sm font-semibold">${escapeHtml(item.price || '')}</p>
      </div>
    </div>`).join('');
  grid.querySelectorAll('[data-wishlist-remove]').forEach(btn => {
    btn.addEventListener('click', function () {
      const handle = btn.getAttribute('data-wishlist-remove');
      saveWishlist(getWishlist().filter(i => i.handle !== handle));
    });
  });
}
function initWishlist() {
  document.querySelectorAll('[data-wishlist]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWishlist({
        handle: btn.getAttribute('data-wishlist-handle'),
        title: btn.getAttribute('data-wishlist-title'),
        image: btn.getAttribute('data-wishlist-image'),
        price: btn.getAttribute('data-wishlist-price'),
        url: btn.getAttribute('data-wishlist-url'),
      });
    });
  });
  updateWishlistUI();
}

// ═══════════════════════ INIT ════════════════════════════════

document.addEventListener('DOMContentLoaded', function() {
  renderCart();
  // Card quick-add (single-variant products)
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const label = btn.textContent;
    btn.textContent = 'ADDING…'; btn.disabled = true;
    await addToCart(btn.dataset.quickAdd, 1, true);
    btn.textContent = label; btn.disabled = false;
  });
  initMegaMenu();
  initMobileShopBy();
  initHeroSlider();
  initCustomerStories();
  initProductPage();
  initAnnouncement();
  initWishlist();
});
